import React from 'react'

import clsx from 'clsx'

import ArticleCard from 'components/ArticleCard'
import { Container } from 'components/Grid'
import { useEventContext } from 'context/EventContext'

import HomeButton from '../HomeButton'
import HomeHeading from '../HomeHeading'
import CategoryHubsCarousel from './components/CategoryHubsCarousel'

import classes from './LatestInsights.module.scss'

/** @type {import("./types").default} */
const LatestInsights = ({ posts, hubsCarousel }) => {
  const { addEvent } = useEventContext()

  return (
    <div className={clsx('LatestInsights', classes.root)}>
      <Container>
        <HomeHeading>Discover the latest expert insights</HomeHeading>
      </Container>
      {!!hubsCarousel?.length && (
        <Container className={classes.carouselContainer}>
          <CategoryHubsCarousel hubsCarousel={hubsCarousel} />
        </Container>
      )}
      <Container>
        <div className={classes.articlesRoot}>
          {posts?.items?.map(post => (
            <ArticleCard key={post.sys.id} post={post} isElevated={false} />
          ))}
        </div>
        <div className={classes.buttonsContainer}>
          <HomeButton
            href="/resources/"
            data-testid="latest-insights-see-more"
            {...addEvent({
              engagementComponent: 'resources_article',
              engagementDestination: 'go-to_resources',
              engagementDetails: 'button_see-more-resources',
              name: 'engagement_facet_click',
            })}
          >
            See more articles
          </HomeButton>
        </div>
      </Container>
    </div>
  )
}

export default LatestInsights
